import React from 'react';
import { Paper, Typography, Box } from '@mui/material';

const PageHeader = ({ title, subtitle, actions = null, rightAction = null, sx = {} }) => (
  <Paper elevation={0} sx={{ p: 3, mb: 4, backgroundColor: 'transparent', ...sx }}>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
      <Box>
        <Typography variant="h4" component="h1" gutterBottom>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="subtitle1" color="text.secondary">
            {subtitle}
          </Typography>
        )}
      </Box>
      {rightAction && (
        <Box>
          {rightAction}
        </Box>
      )}
    </Box>
    {actions && (
      <Typography component="div" sx={{ mt: 2 }}>
        {actions}
      </Typography>
    )}
  </Paper>
);

export default PageHeader;
